import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import ProductActions from '../../Redux/ProductRedux'

class CountryList extends React.Component {
  constructor (props) {
    super(props)
    let countries = []
    props.country_list.map((item, i) => {
      countries[i] = {
        value: item.id,
        label: item.name
      }
      return countries
    })
    this.countries = countries
    this.state = {
      selectedCountry: null,
      form: {
        product_id: props.uuid,
        country_id: ''
      }
    }
  }

  componentDidMount = () => {
    this._getProductCountry()
  }

  _getProductCountry = () => {
    let data = {
      uuid: this.props.uuid
    }
    this.props.get(data)
  }

  _inputChange = (event, field) => {
    let val = event.target.value
    if (event.target.type === 'number') {
      val = parseFloat(val)
    }
    let form = { ...this.state.form }
    form[field] = val
    this.setState({ form })
  }

  _selectChange = (selectedCountry) => {
    let form = { ...this.state.form }
    form.country_id = selectedCountry.value
    this.setState({ selectedCountry, form })
  }

  _delete = (uuid) => {
    let data = { uuid }
    this.props.delete(data)
    setTimeout(() => {
      this._getProductCountry()
    }, 500)
  }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.form }
    this.props.submit(form)
    setTimeout(() => {
      this._getProductCountry()
    }, 500)
  }

  render () {
    const { product } = this.props
    return (
      <section className='section' style={{ width: '50vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>
            {this.props.title} Country List
            {
              (product.fetching || product.processing) &&
              <div className='badge badge-info ml-2'>
                { product.fetching ? 'Loading ...' : 'Processing ...' }
              </div>
            }
          </h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-10'>
              <Select
                options={this.countries}
                value={this.state.selectedCountry}
                onChange={(selectedCountry) => this._selectChange(selectedCountry)}
                placeholder='Select country to assign ...'
              />
            </div>
            <div className='col-2'>
              <button type='submit' className='btn btn-primary'>Assign</button>
            </div>
          </div>
        </form>
        <div className='section'>
          <table className='table table-hover table-striped'>
            <thead>
              <tr>
                <th className='text-center'>Country</th>
                <th className='text-center'>Delete</th>
              </tr>
            </thead>
            <tbody>
              {
                (!product.country || product.country.length === 0)
                  ? <tr>
                    <td className='text-center' colSpan='2'>-- No Data --</td>
                  </tr>
                  : product.country.map((item, i) => (
                    <tr key={i}>
                      <td className='text-center'>{item.country.name}</td>
                      <td className='text-center'>
                        <button onClick={() => this._delete(item.id)} className='btn btn-danger'>
                          <i className='fa fa-trash' />
                        </button>
                      </td>
                    </tr>
                  ))
              }
            </tbody>
          </table>
        </div>
        <div className='row'>
          <div className='col-12 text-right'>
            <button onClick={() => this.props.closeModal()} className='btn btn-secondary mr-2'>Close</button>
          </div>
        </div>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  country_list: state.preset.dataCountries,
  product: state.product
  // country: state.product.country
})

const dispatchToProps = (dispatch) => ({
  get: (data) => dispatch(ProductActions.getProductCountryRequest(data)),
  submit: (data) => dispatch(ProductActions.postProductCountryRequest(data)),
  delete: (data) => dispatch(ProductActions.deleteProductCountryRequest(data))
})

export default connect(stateToProps, dispatchToProps)(CountryList)



// WEBPACK FOOTER //
// ./src/Containers/Product/CountryList.js